// Dispatched on window by the unauthorized-interceptor when repeated "Invalid token" 401
// responses indicate a dead session. SessionTimeoutDialogBase listens and shows the expired modal.
export const FORCE_LOGOUT_EVENT = 'argos:force-logout';
